import { Field, Label, Listbox, ListboxButton, ListboxOption, ListboxOptions } from "@headlessui/react";
import { useState } from "react";
import { Check, ChevronDown } from "lucide-react";
import { cn } from "@/utils/css";

export const Dropdown = ({ items, value, setValue, label, className, placeholder, minWidth = 250, listWidth }) => {
    const [dirty, setDirty] = useState(false);
    const pxMinWidth = `${minWidth}px`; // Ensure minimum width

    return (
        <Field
            className={cn("flex flex-col bg-cm-p-surface-container h-[64px] px-4 py-[10px]", className)}
            style={{ minWidth: pxMinWidth }}
        >
            {label && <Label className="text-cm-p-text-secondary text-sm">{label}</Label>}
            <Listbox
                value={value?.id || null}
                onChange={(v) => {
                    setValue(v);
                    setDirty(true);
                }}
            >
                {({ open }) => (
                    <>
                        <ListboxButton className="inline-flex flex-row justify-between items-center">
                            <span
                                className={`${value?.inputText || value?.text ? "text-cm-p-text-primary font-medium" : "text-cm-text-tertiary"} `}
                            >
                                {value?.inputText || value?.text || placeholder}
                            </span>
                            <ChevronDown
                                className={cn("opacity-50 text-cm-text-primary transition ease-in w-4 h-4", {
                                    "rotate-180": open,
                                })}
                            />
                        </ListboxButton>
                        <ListboxOptions
                            portal={false}
                            modal={true}
                            className={cn(
                                "z-40 flex flex-col mt-[15px] rounded-lg bg-cm-p-surface py-[1px] -ml-4 gap-[2px] border px-[1px] border-cm-p-outline-variation drop-shadow-[0_4px_4px_rgba(0,0,0,0.08)]",
                            )}
                            style={{
                                minWidth: listWidth || pxMinWidth,
                                ...(listWidth
                                    ? {
                                          marginLeft: `-${listWidth - minWidth}px`,
                                      }
                                    : {}),
                            }}
                        >
                            {items.map((item) => (
                                <ListboxOption
                                    key={item.id}
                                    value={item.id}
                                    className="inline-flex min-h-[41px] px-3 items-center cursor-pointer justify-between hover:bg-cm-p-surface-hover rounded-lg"
                                >
                                    <span className="text-cm-p-text-primary font-medium text-sm">{item.text}</span>
                                    {value?.id === item.id ? <Check className="size-4 text-cm-p-text-secondary" /> : null}
                                </ListboxOption>
                            ))}
                        </ListboxOptions>
                    </>
                )}
            </Listbox>
        </Field>
    );
};
